import { render, staticRenderFns } from "./PasswordSprayIssueBody.vue?vue&type=template&id=071d0bb1&scoped=true"
import script from "./PasswordSprayIssueBody.vue?vue&type=script&lang=js"
export * from "./PasswordSprayIssueBody.vue?vue&type=script&lang=js"
import style0 from "./PasswordSprayIssueBody.vue?vue&type=style&index=0&id=071d0bb1&prod&lang=scss&scoped=true"
import style1 from "./PasswordSprayIssueBody.vue?vue&type=style&index=1&id=071d0bb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d0bb1",
  null
  
)

export default component.exports